import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import type { SubscriptionOption } from 'lumen/components/settings/users/base-subscription-select';
import SubscriptionMultiSelect from 'lumen/components/settings/users/subscription-multi-select';

interface AddSubscriptionAccessSignature {
  Args: {
    onAdd: (subscriptionIds: number[], exclude: boolean) => Promise<void>;
    userId: string;
  };
}

const EMPTY_SELECTION: SubscriptionOption[] = [];

function addSubscriptions(
  onAdd: AddSubscriptionAccessSignature['Args']['onAdd'],
): (selectedOptions: SubscriptionOption[], isExcludeMode: boolean) => void {
  return (selectedOptions, isExcludeMode) => {
    // An empty exclude selection means every subscription.
    if (selectedOptions.length === 0 && !isExcludeMode) {
      return;
    }

    void onAdd(
      selectedOptions.map((subscription) => Number(subscription.id)),
      isExcludeMode,
    );
  };
}

const AddSubscriptionAccess: TOC<AddSubscriptionAccessSignature> = <template>
  <div data-test-id="add-subscription-access">
    <SubscriptionMultiSelect
      @emptyLabel={{t "settings.users.add_subscription.trigger_label"}}
      @onChange={{addSubscriptions @onAdd}}
      @userId={{@userId}}
      @value={{EMPTY_SELECTION}}
    />
  </div>
</template>;

export default AddSubscriptionAccess;
